import { render } from "./EditorPage.vue?vue&type=template&id=122e6ece&scoped=true&ts=true"
import script from "./EditorPage.vue?vue&type=script&lang=ts"
export * from "./EditorPage.vue?vue&type=script&lang=ts"

import "./EditorPage.vue?vue&type=style&index=0&id=122e6ece&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122e6ece"]])

export default __exports__